import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/blogg/")({
  beforeLoad: () => {
    throw redirect({ to: "/nyhet", statusCode: 301 });
  },
});
